// #EventID | Time | Latitude | Longitude | Depth/km | Author | Catalog | Contributor |
//  ContributorID | MagType | Magnitude | MagAuthor | EventLocationName

export enum AgeColors {
  HOUR,
  DAY,
  WEEK,
  MONTH,
  YEAR,
}

export class MapCoordinate {
  latitude: number;
  longitude: number;

  constructor(lat?: number, lng?: number) {
    this.latitude = lat;
    this.longitude = lng;
  }
}

enum header {
  id,
  time,
  latitude,
  longitude,
  depth,
  author,
  catalog,
  contributor,
  contributorID,
  magType,
  magnitude,
  magAuthor,
  eventLocationName,
}

export class Quake extends MapCoordinate {
  static fromObject(el: any): Quake {
    const q = new Quake();
    Object.assign(q, el);

    // compatibility layer with older local database.
    if (!(typeof q.time.getMonth === 'function')) {
      q.time = new Date(q.time + 'Z');
    }
    return q;
  }

  id: string;
  time: Date;
  depth: number;
  author: string;
  catalog: string;
  contributor: string;
  contributorID: string;
  magType: string;
  magnitude: number;
  magAuthor: string;
  eventLocationName: string;

  toString(): string {
    return `M ${this.magnitude} ${this.time.toLocaleString()} ${this.eventLocationName}`
  }

  fromString(str: string): Quake {
    const strArr = str.trim().split('|');
    this.id = strArr[header.id];
    this.time = new Date(strArr[header.time] + 'Z');
    this.latitude = Number(strArr[header.latitude]);
    this.longitude = Number(strArr[header.longitude]);
    this.depth = Math.max(Number(strArr[header.depth]), 0);
    this.author = strArr[header.author];
    this.catalog = strArr[header.catalog];
    this.contributor = strArr[header.contributor];
    this.contributorID = strArr[header.contributorID];
    this.magType = strArr[header.magType];
    this.magnitude = Number(strArr[header.magnitude]);
    this.magAuthor = strArr[header.magAuthor];
    this.eventLocationName = strArr[header.eventLocationName];
    return this;
  }

  getEventColorIndex(): number {
    const hours = (Date.now() - this.time.getTime()) / 1000 / 60 / 60;
    if (hours <= 1) {
      return AgeColors.HOUR;
    } else if (hours < 24) {
      return AgeColors.DAY;
    } else if (hours < 24 * 7) {
      return AgeColors.WEEK;
    } else if (hours < 24 * 30) {
      return AgeColors.MONTH;
    } else {
      return AgeColors.YEAR;
    }
  }
}
